import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  Button, 
  Grid, 
  Box, 
  Skeleton,
  IconButton 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CrossingTradeRebalancerSkeleton = ({ openCrossPopup, handleClose, showNext }) => {
  return (
    <Dialog
      open={openCrossPopup}
      fullWidth
      sx={{
        "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
          minWidth: "1000px",
          height: "100vh",
        },
      }}
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            align="left"
            style={{ flexGrow: 1, fontSize: "20px" }}
          >
            Orders
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers>
        {/* Table Container */}
        <Box sx={{ height: "360px" }}>
          {/* Table Header */}
          <Box sx={{ display: "flex", mb: 2, borderBottom: "1px solid #e0e0e0", pb: 1 }}>
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={100} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>

          {/* Table Rows - Multiple rows to show scrollable content */}
          {Array.from({ length: 10 }).map((_, index) => (
            <Box key={index} sx={{ display: "flex", mb: 1, py: 0.5 }}>
              <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={100} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={80} height={16} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={100} height={16} />
            </Box>
          ))}
        </Box>

        {/* Action Buttons */}
        {showNext && (
          <Grid
            size={{ xs: 12 }} 
            margin="20px 1px 20px 1px"
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
           
            <Skeleton
              variant="rectangular"
              width="40%"
              height={40}
              sx={{ borderRadius: 1 }}
            />
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CrossingTradeRebalancerSkeleton; 